import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid";

import { HStack } from "@/components/layout";

const extractYear = (id) => {
  const match = id.match(/\d+/);
  return match ? match[0] : null;
};

const getTitle = (id) => {
  const year = extractYear(id);
  return `Read the rest of the ${year} report`;
};

export default function ReaderControl({ onClick, sectionId, isActive }) {
  return (
    <HStack className="relative mt-4 justify-between">
      <button
        onClick={onClick}
        className="text-cp-body border-cp-grey-250 w-full border-b text-start text-sm font-medium leading-7 hover:opacity-80"
      >
        {getTitle(sectionId)}
      </button>
      <div className="absolute right-0">
        {isActive ? (
          <ChevronDownIcon className="text-cp-grey-500 h-5 w-5" />
        ) : (
          <ChevronUpIcon className="text-cp-grey-500 h-5 w-5" />
        )}
      </div>
    </HStack>
  );
}
